import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

const http = createDashHttpClient(env.shortURLServiceApiUrl, {
  camelizeKeys: true,
  decamelizeRequests: true,
});

export async function shortenUrl({ url, brandId }, config = {}) {
  return http.post(
    '/api/urls',
    {
      url,
      brandId,
      type: 'SCHEDULER',
    },
    config,
  );
}

export async function getUrlInfo(shortCode, config = {}) {
  return http.get(`/api/urls/${shortCode}`, config);
}

export default {
  shortenUrl,
  getUrlInfo,
};
